import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Vaccine = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="m12.7 31.2-5.2 5.3m23.7-23.8-3.9 4m-11 4.6 3.3 3.3m.8-7.3 3.3 3.2m9.7 2.3L21.1 10.5m9.1 9.3L18.5 31.5l-5.8-.3-.3-5.8 11.7-11.7"
    />
    <path fill={props.fill} d="m27.6 9 2.9-2.8 5.7 5.7v5.7L27.6 9z" />
    <path
      fill="currentColor"
      d="M10.1 7.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5zM5.35 11a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0z"
    />
    <path
      fill="currentColor"
      d="m12.1 4-2 3-2-3h4zm4.3 3.5-3.5.7.7-3.6 2.8 2.9zm.7 5.5-3-2 3-2v4zm-3.5 4.4-.7-3.6 3.5.8-2.8 2.8zm-5.5.6 2-3 2 3h-4zm-4.4-3.4 3.5-.8-.7 3.6-2.8-2.8zM3 9l3 2-3 2V9zm3.5-4.4.7 3.6-3.5-.7 2.8-2.9z"
    />
  </svg>
);

export default SvgCovid19Vaccine;
